import $ from 'jquery';

// 地図要素表示切り替え
export const mapSetting = (type, $hallMap, $salonMap) => {
    if (type === 'hall') {
        $hallMap.show();
        $salonMap.hide();
    } else {
        $hallMap.hide();
        $salonMap.show();
    }
};
// タブのアクティブ切り替え
export const tabSetting = type => {
    const activeClass =
        'is-active background-color--accent border-color--accent';
    const inActiveClass =
        'background-color--page_bg border-color--border color--text';

    $('#tabs--map li')
        .children('a')
        .removeClass(activeClass)
        .addClass(inActiveClass);
    $(`.${type}`)
        .children('a')
        .removeClass(inActiveClass)
        .addClass(activeClass);
};
